module.exports = __webpack_public_path__ + "img/prelude.5ae12947.png";